import { Component, Input, OnInit } from '@angular/core';
import { PricePipe } from '../../../utils/pipes/price';

@Component({
  selector: 'unco-precio-metrica',
  templateUrl: './precio.html',
  styleUrls: ['./precio.scss']
})
export class PrecioMetrica implements OnInit {

  @Input() delivery: string = '';
  @Input() value: string = '';
  @Input() currency: string = '';
  @Input() variance: number = 0;
  @Input() time: string = '';
  @Input() mercado: string = '';

  private color: string = '';
  private _variance: string = '';

  constructor(private pricePipe: PricePipe) {
  }

  ngOnInit() {
    console.log(this.mercado);
    this.color = this.variance < 0 ? 'red' : (this.variance === 0 ? 'gray' : 'green');
    this._variance = (this.variance < 0 ? '' : (this.variance > 0 ? '+' : '')) + this.pricePipe.transform(String(this.variance));
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/precio/precio.ts